 <template>
  <div>
    <div
      class="product_single_share"
      v-if="socialMedias.show_style == 'default'&&(socialMedias.enable_facebook || socialMedias.enabel_pinterest || socialMedias.enabel_pinterest)"
      :class="{ athena_single_share: theme == 'athena' }"
    >
      <div
        class="social-sharing"
        :class="{
          'text-center': theme == 'vogue',
          'text-left': theme == 'athena',
          show_social_name: show_name,
        }"
      >
        <social-sharing
          :title="product_res.post_title"
          :description="product_res.post_title"
          :media="
            product_res.gallery.length ? product_res.gallery[0].url : 'null'
          "
          inline-template
          @open="share_event"
          v-if="socialMedias.enable_facebook"
        >
          <network network="facebook">
            <i class="iconfont icon-cm-icomoonfacebook main_button_color2"></i>
            <i class="main_button_color2"> Facebook </i>
          </network>
        </social-sharing>
        <social-sharing
          :title="product_res.post_title"
          :description="product_res.post_title"
          :media="
            product_res.gallery.length ? product_res.gallery[0].url : 'null'
          "
          inline-template
          @open="share_event"
          v-if="socialMedias.enable_twitter"
        >
          <network network="twitter">
            <i class="iconfont icon-cm-twitter main_button_color2"></i>
            <i class="main_button_color2"> Twitter </i>
          </network>
        </social-sharing>
        <social-sharing
          :title="product_res.post_title"
          :description="product_res.post_title"
          :media="
            product_res.gallery.length ? product_res.gallery[0].url : 'null'
          "
          inline-template
          @open="share_event"
          v-if="socialMedias.enabel_pinterest"
        >
          <network network="pinterest">
            <i class="iconfont icon-cm-_pinterest main_button_color2"></i>
            <i class="main_button_color2"> Pinterest </i>
          </network>
        </social-sharing>
      </div>
    </div>
    <div
      class="product_action"
      v-if="socialMedias.show_style == 'expand'"
      v-show="socialMedias.enable_facebook || socialMedias.enabel_pinterest || socialMedias.enabel_pinterest"
    >
      <button
        class="round_button"
        :class="{ 'is-active': active }"
        @click="active = !active"
        v-clickoutside="handleClose"
      >
        <span v-show="!active" class="round_button_primarystate">
          <svg class="Icon Icon--share" role="presentation" viewBox="0 0 24 24">
            <g
              stroke="currentColor"
              fill="none"
              fill-rule="evenodd"
              stroke-width="1.5"
            >
              <path d="M8.6,10.2 L15.4,6.8"></path>
              <path d="M8.6,13.7 L15.4,17.1"></path>
              <circle stroke-linecap="square" cx="5" cy="12" r="4"></circle>
              <circle stroke-linecap="square" cx="19" cy="5" r="4"></circle>
              <circle stroke-linecap="square" cx="19" cy="19" r="4"></circle>
            </g>
          </svg>
        </span>
        <span
          :class="{ 'active-show': active }"
          class="round_button_secondarystate"
          style="color: #fff"
        >
          <svg class="Icon Icon--close" role="presentation" viewBox="0 0 16 14">
            <path
              d="M15 0L1 14m14 0L1 0"
              stroke="currentColor"
              fill="none"
              fill-rule="evenodd"
            ></path>
          </svg>
        </span>
      </button>
      <div class="product_share_list" :class="{ list_show: active }">
        <social-sharing
          :title="product_res.post_title"
          :description="product_res.post_title"
          :media="
            product_res.gallery.length ? product_res.gallery[0].url : 'null'
          "
          inline-template
          @open="share_event"
          v-if="socialMedias.enable_facebook"
        >
          <network network="facebook">
            <div class="product_share_item">
              <i
                class="iconfont icon-cm-icomoonfacebook main_button_color2"
              ></i>
              <span>Facebook</span>
            </div>
          </network>
        </social-sharing>
        <social-sharing
          :title="product_res.post_title"
          :description="product_res.post_title"
          :media="
            product_res.gallery.length ? product_res.gallery[0].url : 'null'
          "
          inline-template
          @open="share_event"
          v-if="socialMedias.enabel_pinterest"
        >
          <network network="pinterest">
            <div class="product_share_item">
              <i class="iconfont icon-cm-_pinterest main_button_color2"></i>
              <span>Pinterest</span>
            </div>
          </network>
        </social-sharing>
        <social-sharing
          :title="product_res.post_title"
          :description="product_res.post_title"
          :media="
            product_res.gallery.length ? product_res.gallery[0].url : 'null'
          "
          inline-template
          @open="share_event"
          v-if="socialMedias.enable_twitter"
        >
          <network network="twitter">
            <div class="product_share_item">
              <i class="iconfont icon-cm-twitter main_button_color2"></i>
              <span>Twitter</span>
            </div>
          </network>
        </social-sharing>
      </div>
    </div>
    <div
      class="share-fixed-right"
    >
      <template  v-if="socialMedias.show_style == 'right'">
          <div 
          class="share-fixed-right__button-mb"
          @click="shareButtonMbActive = !shareButtonMbActive"
          v-clickoutside="handleMbClose"
          v-if="socialMedias.enable_facebook || socialMedias.enabel_pinterest || socialMedias.enable_twitter"
        >
        <i class="iconfont icon-cm-fenxiang"></i>
        </div>
        <div class="share-fixed-right__icon-list" :class="{ 'list-show-mb': shareButtonMbActive }">
          <social-sharing
            :title="product_res.post_title"
            :description="product_res.post_title"
            :media="
              product_res.gallery.length ? product_res.gallery[0].url : 'null'
            "
            inline-template
            @open="share_event"
            v-if="socialMedias.enable_facebook"
          >
            <network network="facebook">
              <div class="share-item">
                <i class="marketing-popups__share-icon--fb iconfont icon-cm-facebook2" style="color: #485893;">
                  
                </i><span>Facebook</span>
              </div>
            </network>
          </social-sharing>
          <social-sharing
            :title="product_res.post_title"
            :description="product_res.post_title"
            :media="
              product_res.gallery.length ? product_res.gallery[0].url : 'null'
            "
            inline-template
            @open="share_event"
            v-if="socialMedias.enabel_pinterest"
          >
            <network network="pinterest">
              <div class="share-item">
                <i class="marketing-popups__share-icon--ins iconfont icon-cm-pinterest2" style="color: #cc1f28;">
                  
                </i><span>Pinterest</span>
              </div>
            </network>
          </social-sharing>
          <social-sharing
            :title="product_res.post_title"
            :description="product_res.post_title"
            :media="
              product_res.gallery.length ? product_res.gallery[0].url : 'null'
            "
            inline-template
            @open="share_event"
            v-if="socialMedias.enable_twitter"
          >
            <network network="twitter">
              <div class="share-item">
                <i class="marketing-popups__share-icon--tw iconfont icon-cm-twitter2" style="color: #069ff6;">
                  
                </i><span>Twitter</span>
              </div>
            </network>
          </social-sharing>
        </div>
      </template>
      <div class="share-fixed-right__icon-top" v-if="theme_name==='default'">
          <el-backtop  class="to-top-btn" :visibility-height="600">
            <i class="iconfont icon-cm-tubiao_fanhuidingbu" />
          </el-backtop>
      </div>
    </div>
  </div>
</template>

<script>
import mixClose from "@/js/mixins/mixClose";
import { mapState } from "vuex";
export default {
  props: [
    "show_style",
    "product_res",
    "share_event",
    "enable_facebook",
    "enable_twitter",
    "enabel_pinterest",
    "theme",
    "show_name",
  ],
  data() {
    return {
      active: false,
      shareButtonMbActive: false
    };
  },
  computed: {
    ...mapState({
      theme_name: ({ theme_name }) => theme_name,
      socialMedias: ({ options }) => options?.theme?.global?.social_medias
    }),
  },
  mixins: [mixClose],
  methods: {
    handleClose() {
      this.active = false;
    },
    handleMbClose() {
      this.shareButtonMbActive = false;
    }
  },
};
</script>

<style scoped lang='scss'>
//分享模块：屏幕右侧
.share-fixed-right {
  position: fixed;
  right: 8px;
  top: 56%;
  z-index: 201;
  text-align: right;
  //展开按钮：只在移动端显示
  &__button-mb {
    display: none;
  }
  //分享图标列表
  &__icon-list {
    display: flex;
    flex-direction: column;
    width: 35px;
    &::v-deep{
      .share-item {
        cursor: pointer;
        margin-bottom: 8px;
        transform: translateX(calc(100% - 32px));
        float: right;
        display: flex;
        align-items: center;
        i {
          font-size: 35px;
          &::before {
            display: flex;
            border-radius: 50%;
            overflow: hidden;
            background-color: #FFFFFF;
            height: 32px;
            width: 32px;
            align-items: center;
            justify-content: center;
          } 
        }
        span {
          color: #000000;
          font-family: Roboto;
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 14px;
          margin-left: 8px;
          margin-right: 16px; 
          white-space: nowrap;
        }
        &:hover {
          animation: showShareTitle 1s ;
          animation-iteration-count: 1;
          animation-fill-mode: forwards;
          animation-timing-function: ease;
        }
      }
    }
    //pc端鼠标悬停的动画效果
    @keyframes showShareTitle {
      0% {
        -webkit-transform: translateX(calc(100% - 32px));
        transform: translateX(calc(100% - 32px));
      }
      100% {
        -webkit-transform: translateX(0);
        transform: translateX(0);
      }
    }
  }
  &__icon-top {
    display: inline-block;
    .to-top-btn {
      position: unset;
      background: rgba(0, 0, 0, 0.4);
      width: 32px;
      height: 32px;
      & > i {
        color: white;
        font-size: 20px;
      }
    }
  }
  //移动端分享模块：屏幕右侧
  @media screen and (max-width: 768px) {
    & {
      z-index: 201;
      overflow: hidden;
    }
    &__button-mb {
      display: block;
      width: 32px;
      height: 32px;
      margin-left: auto;
      margin-right: 0;
      margin-bottom: 8px;
      background: rgba(0, 0, 0, 0.4);
      text-align: center;
      border-radius: 50%;
      i {
        line-height: 32px;
        color: #FFFFFF;
      }
      &:active {
        background: rgba(0, 0, 0, 0.3);
      }
    }
    &__icon-list {
      overflow: hidden;
      max-height: 0;
      transition: all 0.5s;
      &::v-deep{
        .share-item {
          i {
            display: inline-grid;
            border-radius: 50%;
            overflow: hidden;  
          }
          span {
            display: none;
          }
        }
      }
    }
    .list-show-mb {
      max-height: 200px;
    }
  }
}

.product_single_share {
  .social-sharing {
    text-align: center;
    margin: 0;
    padding-left: 0px;
    span {
      display: inline-block;
      margin: 3px 6px;
      font-size: 16px;
      width: 18px;
      height: 18px;
      line-height: 18px;
      color: #b89797;
      cursor: pointer;
      :last-child {
        display: none;
      }
    }
  }
  .show_social_name {
    span {
      width: auto;
      :last-child {
        display: inline;
        font-style: normal;
      }
    }
  }
}
.athena_single_share {
  margin-top: 21px !important;
  border-top: 1px solid #e2e2e2;
  padding-top: 20px;
  .social-sharing {
    & > span {
      margin-right: 20px;
    }
  }
  @media screen and (max-width: 768px) {
    border-top: none;
    margin-top: 10px !important;
    padding-top: 0;
    .social-sharing {
      text-align: center !important;
      span {
        font-size: 12px;
      }
    }
  }
}
.product_action {
  position: absolute;
  right: 5px;
  top: 65px;
}
.round_button {
  box-shadow: 0 1px 5px rgb(54 54 54 / 43%);
  color: rgba(0, 0, 0, 0.5);
  width: 35px;
  height: 35px;
  position: relative;
  border: none;
  border-radius: 50%;
  background: #fff;
  cursor: pointer;
  text-align: center;
  z-index: 1;
  vertical-align: middle;
  line-height: 0;
  overflow: hidden;
  &:hover {
    color: #000;
    transform: scale(1.15);
    svg {
      -webkit-animation: buttonFromTopToBottom 0.5s ease-in-out forwards;
      animation: buttonFromTopToBottom 0.5s ease-in-out forwards;
    }
  }
  svg {
    height: 14px;
    width: 14px;
  }
}
.round_button_primarystate,
.round_button_secondarystate {
  display: block;
  -webkit-transition: opacity 0.4s cubic-bezier(0.75, 0, 0.125, 1),
    -webkit-transform 0.4s cubic-bezier(0.75, 0, 0.125, 1);
  transition: opacity 0.4s cubic-bezier(0.75, 0, 0.125, 1),
    -webkit-transform 0.4s cubic-bezier(0.75, 0, 0.125, 1);
  transition: transform 0.4s cubic-bezier(0.75, 0, 0.125, 1),
    opacity 0.4s cubic-bezier(0.75, 0, 0.125, 1);
  transition: transform 0.4s cubic-bezier(0.75, 0, 0.125, 1),
    opacity 0.4s cubic-bezier(0.75, 0, 0.125, 1),
    -webkit-transform 0.4s cubic-bezier(0.75, 0, 0.125, 1);
}
.round_button_secondarystate {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 100%;
  text-align: center;
  opacity: 0;
  -webkit-transform: translate(-50%, 100%);
  transform: translate(-50%, 100%);
}
.Icon {
  display: inline-block;
  height: 1em;
  width: 1em;
  fill: currentColor;
  vertical-align: middle;
  stroke-width: 1px;
  background: 0 0;
  pointer-events: none;
}
.is-active {
  background: var(--main-btn-bg);
  color: #fff;
}
.active-show {
  transform: translate(-50%, -50%);
  opacity: 1;
}
.list_show {
  visibility: visible !important;
}
.product_share_list {
  display: block;
  font-family: Muli;
  position: absolute;
  visibility: hidden;
  top: 100%;
  bottom: auto;
  right: 0;
  color: #454545;
  z-index: 999;
  &::v-deep {
    .product_share_item {
      display: block;
      line-height: 1.65;
      cursor: pointer;
      margin: 15px 0 15px auto;
      padding: 7px 15px 7px 17px;
      width: -webkit-fit-content;
      width: -moz-fit-content;
      width: fit-content;
      background: #fff;
      border-radius: 25px;
      font-size: 13px;
      white-space: nowrap;
      opacity: 1;
      -webkit-box-shadow: 0 2px 10px rgb(54 54 54 / 15%);
      box-shadow: 0 2px 10px rgb(54 54 54 / 15%);
      -webkit-transition: all 0.45s cubic-bezier(0.645, 0.045, 0.355, 1) 0.2s;
      transition: all 0.45s cubic-bezier(0.645, 0.045, 0.355, 1) 0.2s;
      -webkit-transition-delay: 0.2s;
      transition-delay: 0.2s;
      overflow: hidden;
      span {
        margin-left: 5px;
      }
      i {
        display: inline-block;
      }
      &:hover i {
        animation: shareItemAnimation 0.5s ease-in-out forwards;
      }
    }
    @keyframes shareItemAnimation {
      0% {
        -webkit-transform: translateY(0);
        transform: translateY(0);
      }
      25% {
        opacity: 0;
        -webkit-transform: translateY(100%);
        transform: translateY(100%);
      }
      50% {
        opacity: 0;
        -webkit-transform: translateY(-100%);
        transform: translateY(-100%);
      }
      75% {
        opacity: 1;
        -webkit-transform: translateY(0);
        transform: translateY(0);
      }
    }
  }
}

@keyframes buttonFromTopToBottom {
  0% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
  25% {
    opacity: 0;
    -webkit-transform: translateY(100%);
    transform: translateY(100%);
  }
  50% {
    opacity: 0;
    -webkit-transform: translateY(-100%);
    transform: translateY(-100%);
  }
  75% {
    opacity: 1;
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
}
@media screen and(max-width:1480px ) {
  .product_action {
    right: 8px;
  }
}

@media screen and(max-width:768px) {
  .product_action {
    right: 20px;
    transform: unset;
    top: 60px;
  }
}
</style>